import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles  } from '@mui/styles';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import { Button as ReactButton } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import Dialog from '@mui/material/Dialog';
import Divider from '@mui/material/Divider';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import FormHelperText from '@mui/material/FormHelperText';
import Slide from '@mui/material/Slide';
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import {
  Close,
  AttachFile,
  CloudUpload,
  ImportExport as ImportIcon,
  CloudDownload
} from '@mui/icons-material';
import Grid from "@mui/material/Grid";
import { WithTracking } from "./WithTracking";

const Button = WithTracking(ReactButton);

const styles = theme => ({
  leftIcon: {
    marginRight: theme.spacing(1)
  },
  flex: {
    display: 'flex'
  },
  white: {
    color: theme.palette.common.white
  },
  title: {
    color: theme.palette.common.white,
    flex: 1
  },
  bold: {
    fontWeight: 700
  },
  content: {
    padding: 20
  },
  section: {
    margin: '20px 10px'
  },
  button: {
    marginTop: 20,
    marginLeft: theme.spacing(2),
    color: theme.palette.common.white
  },
  hidden: {
    display: 'none'
  },
  right: {
    textAlign: 'right'
  },
  importError: {
    color: theme.palette.error.main,
    fontSize: '1.1rem',
    fontWeight: 700
  }
});

const pFields = [
  'Cost Types',
  'Package Types',
  'Viewability',
  'Data Fee Types',
  'HDM Pubs',
  'CDRT Pubs',
  'HOO Pubs',
  'Strategies',
  'Device Types',
  'Sales Products',
  'Creative Products',
  'Aura Targeting',
  'Category Targeting',
  'How To Targeting',
  'Make Targeting',
  'Model Targeting',
  'Persona Targeting',
  'QA Category Targeting',
  'Subcategory Targeting',
  'Suggestive Targeting',
  'States',
  'Provinces',
  'Territories',
  'DMAs',
  'Neighborhoods CA',
  'Cities CA',
  'Neighborhoods US',
  'Cities US',
  'Counties',
  'Regions',
  'Countries'
];

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

class ImportExport extends Component {

  file = null;

  state = {
    fileError: false,
    fileCaption: '',
    pickedField: '',
  };

  loaded = e => {
    const file = e.target.files[0];
    if (!file) {
      return;
    }
    if (file.name) {
      this.file = file;
      this.setState({
        fileCaption: `Selected File: ${this.file.name}`,
        fileError: false
      });
    }
  };

  doImport = () => {
    if (!this.file) {
      this.setState({
        fileError: true,
        fileCaption: 'No file selected'
      });
      return;
    }
    this.props.onImport(this.file);
    this.setState({
      fileError: false,
      fileCaption: ''
    });
  };

  createErrorList = (err, idx) => {
    const { classes } = this.props;
    return (
      <ListItem key={idx}>
        <ListItemText
          primary={err}
          primaryTypographyProps={{
            className: classes.importError
          }}
        />
      </ListItem>
    );
  };

  listFields = () => {
    const { constants, presets, geos } = this.props;
    const { pickedField } = this.state;
    let items = [];
    if (pickedField === 'Cost Types') {
      items = constants.ioRateTypes.map(ior => ior.name);
    } else if (pickedField === 'Package Types') {
      items = constants.packageTypes;
    } else if (pickedField === 'Viewability') {
      items = constants.viewabilityTypes;
    } else if (pickedField === 'Data Fee Types') {
      items = constants.dataFeeTypes.map(dft => dft.name.split(' - ')[1]);
    } else if (pickedField === 'HDM Pubs') {
      items = constants.pubsHDM.map(pub => pub.name);
    } else if (pickedField === 'CDRT Pubs') {
      items = constants.pubsCDRT.map(pub => pub.name);
    } else if (pickedField === 'HOO Pubs') {
      items = constants.pubsHOO.map(pub => pub.name);
    } else if (pickedField === 'Strategies') {
      items = this.props.strategies.map(str => str.name);
    } else if (pickedField === 'Device Types') {
      items = this.props.deviceTypes.map(dt => dt.name);
    } else if (pickedField === 'Sales Products') {
      items = this.props.salesProducts.map(sp => sp.name);
    } else if (pickedField === 'Creative Products') {
      items = this.props.creativeProducts.map(cp => cp.name);
    } else if (pickedField === 'Category Targeting') {
      items = presets.filter(p => p.CustomCriteriaPresetType.id === 1).map(p => p.name);
    } else if (pickedField === 'Make Targeting') {
      items = presets.filter(p => p.CustomCriteriaPresetType.id === 5).map(p => p.name);
    } else if (pickedField === 'Model Targeting') {
      items = presets.filter(p => p.CustomCriteriaPresetType.id === 3).map(p => p.name);
    } else if (pickedField === 'Persona Targeting') {
      items = presets.filter(p => p.CustomCriteriaPresetType.id === 2).map(p => p.name);
    } else if (pickedField === 'Aura Targeting') {
      items = presets.filter(p => p.CustomCriteriaPresetType.id === 4).map(p => p.name);
    } else if (pickedField === 'Subcategory Targeting') {
      console.log('subcategory ----------------------------')
      items = presets.filter(p => p.CustomCriteriaPresetType.id === 9).map(p => p.name);
      console.log(items);
    } else if (pickedField === 'Suggestive Targeting') {
      items = presets.filter(p => p.CustomCriteriaPresetType.id === 7).map(p => p.name);
    } else if (pickedField === 'How To Targeting') {
      items = presets.filter(p => p.CustomCriteriaPresetType.id === 6).map(p => p.name);
    } else if (pickedField === 'QA Category Targeting') {
      items = presets.filter(p => p.CustomCriteriaPresetType.id === 8).map(p => p.name);
    } else if (['States',
      'Provinces',
      'Territories',
      'DMAs',
      'Neighborhoods CA',
      'Cities CA',
      'Neighborhoods US',
      'Cities US',
      'Counties',
      'Regions',
      'Countries'].includes(pickedField)) {
      items = this.getGeos(geos, pickedField);
    }
    if (items.length > 0) {
      return items.map((item, idx) => this.createFieldList(item, idx));
    } else {
      return [];
    }
  }

  createFieldList = (item, idx) => {
    return (
      <ListItem key={idx}>
        <ListItemText primary={item}/>
      </ListItem>
    );
  }

  getGeos = (geos, type) => {
    const xlate = new Map([
      ['States','states'],
      ['Provinces','provinces'],
      ['Territories','territories'],
      ['DMAs','dmas'],
      ['Neighborhoods CA','CA_neighborhoods'],
      ['Cities CA','CA_cities'],
      ['Neighborhoods US','US_neighborhoods'],
      ['Cities US','US_cities'],
      ['Counties','counties'],
      ['Regions','regions'],
      ['Countries', 'countries']
    ]);
    const cleanGeos = geos.filter(g => g.name === xlate.get(type)).map(g => g.items);
    return cleanGeos[0];
  }

  onPickField = evt => {
    this.setState({ pickedField: evt.target.value });
  };

  render() {
    const {
      classes,
      onExport,
      importErrors,
      open,
      toggleImportExport,
      isLocked,
      onTemplateDownload,
    } = this.props;

    return (
      <div>
        <Button onClick={toggleImportExport} color="primary" disabled={isLocked} tracking={{action: "Import/Export"}}>
          <ImportIcon className={classes.leftIcon} />
          Import/Export
        </Button>
        <Dialog
          fullScreen
          open={open}
          onClose={toggleImportExport}
          TransitionComponent={Transition}
        >
          <AppBar position="static">
            <Toolbar>
              <Typography variant="h6" className={classes.title}>
                Import / Export Order
              </Typography>
              <IconButton
                className={classes.white}
                onClick={toggleImportExport}
                aria-label="Close"
                size="large">
                <Close />
              </IconButton>
            </Toolbar>
          </AppBar>

          <div className={classes.content}>
            <div className={classes.section}>
              <Typography variant="h5" gutterBottom color="primary">
                Export
              </Typography>
              <Typography paragraph>
                You can export information from any order in Galileo or an empty template to create new lines.
              </Typography>
              <Typography paragraph>
                If there are packages on the order, they will be exported ahead of their placements.
              </Typography>
              <Typography>
                For new lines, download the empty CSV template for the order, then copy the agency
                info to the corresponding columns in your CSV file.
                Leave the &#39;id&#39; and &#39;cookie&#39; columns empty.
                <Typography paragraph>
                  Alternatively, export a similar order, delete the contents of
                  the &#39;id&#39; and &#39;cookie&#39; columns, and import as
                  new lines to that or a different order.
                </Typography>
                <Typography paragraph>
                  For updates, export the CSV file containing all the placement data for the order.
                  This can be used for QA or edited and imported back.
                  Do not change the &#39;id&#39; and &#39;cookie&#39;
                  columns which identify that line on that order.
                </Typography>
              </Typography>
              <div align="right">
                <Button
                  className={classes.button}
                  onClick={onExport}
                  color="primary"
                  variant="contained"
                  tracking={{action: "Export"}}
                >
                  <ImportIcon className={classes.leftIcon} />
                  Export
                </Button>
                <Button
                  className={classes.button}
                  onClick={onTemplateDownload}
                  color="primary"
                  variant="contained"
                  tracking={{action: "Download Empty Export Template"}}
                >
                  <CloudDownload className={classes.leftIcon} />
                  Download Empty Template
                </Button>
              </div>
            </div>

            <Divider />

            <div className={classes.section}>
              <Typography variant="h5" gutterBottom color="primary">
                Import
              </Typography>
              <Typography paragraph>
                You can import information to your IO in bulk. This includes all data on the placement,
                or all except targeting if you so choose.
              </Typography>
              <Typography paragraph>
                If there are packages, they should be on a separate line before the placements that allocate their impressions.
              </Typography>
              <Typography>
                Select a CSV file and import it.
                If there are validation errors, they will be reported in
                the ERRORS CSV. If there are no errors, the data in the file will be applied to the order.
                Lines with ids will be updated, lines without ids will be created.
              </Typography>

              <List dense>
                {importErrors && importErrors.map(this.createErrorList)}
              </List>
              <div align="right">
                <input
                  accept="text/csv"
                  className={classes.hidden}
                  id="select-import-file"
                  onChange={this.loaded}
                  multiple
                  type="file"
                />
                <label htmlFor="select-import-file">
                  <Button
                    variant="contained"
                    color="primary"
                    component="span"
                    className={classes.button}
                  >
                    <AttachFile className={classes.leftIcon} />
                    Select File
                  </Button>
                </label>
                <Button
                  className={classes.button}
                  onClick={this.doImport}
                  color="primary"
                  variant="contained"
                  tracking={{action: "Import"}}
                >
                  <CloudUpload className={classes.leftIcon} />
                  Import
                </Button>
              </div>

                <FormHelperText
                  className={classes.right}
                  error={this.state.fileError}
                >
                  {this.state.fileCaption}
                </FormHelperText>
            </div>

            <Divider />

            <div className={classes.flex}>
              <Typography  variant="h5" gutterBottom color="primary">
                User Guide
              </Typography>
            </div>
            <Grid container spacing={3}>
            <Grid item xs={6}>
            <List>
              <ListItem>
                <ListItemText
                  primary="Do not change any column headings. Save as a CSV, not Excel."
                />
              </ListItem>
              <ListItem>
                <ListItemText
                  primary="Required fields for non-programmatic orders are:"
                  secondary="Agency Placement Id, Agency Placement Name, Start, End, Io Rate, Io Rate Type, Contracted Quantity, Viewability, Package Type"
                />
              </ListItem>
              <ListItem>
                <ListItemText
                  primary="Don't use commas anywhere. "
                  secondary="Lists of items should be separated by semi-colons[;] not commas."
                />
              </ListItem>
              <ListItem>
                <ListItemText
                  primary="You can omit custom targeting entirely or else all fields are needed."
                  secondary="That includes Strategy, Sales Product, Device Types, Creative Products and [for some Sales Products] Presets, Pubs, and Exclusions"
                />
              </ListItem>
              <ListItem>
                <ListItemText
                  primary="Geotargeting is currently supported on a limited basis."
                  secondary="DMAs, States, Provinces, Territories, Neighborhoods, Counties, Regions, Countries and Cities can be entered in their own columns as ;-separated lists. If a value has an internal comma or apostrophe, omit it. Other Geotargets are exported but will not be imported."
                />
              </ListItem>
              <ListItem>
                <ListItemText
                  primary="Dates should be in MM/DD/YY format."
                />
              </ListItem>
              <ListItem>
                <ListItemText
                  primary="When updating placements, do not alter the contents of the 'id' and 'cookie' columns."
                  secondary="When creating new placements, leave these empty."
                />
              </ListItem>

              <ListItem>
              <ListItemText
                primary="To see all the allowed values for any field, use the Field Values widget on the right side."
              />
              </ListItem>
            </List>
            </Grid>
            <Grid item xs={6}>
              <TextField
                variant="standard"
                fullWidth
                select
                name="pField"
                onChange={this.onPickField}
                margin="normal"
                label="Field Values"
                value={this.state.pickedField}
                SelectProps={{
                  MenuProps: {
                    className: classes.menu
                  }
                }}>
                {pFields.map(type => (
                  <MenuItem key={type} value={type}>
                    {type}
                  </MenuItem>
                ))}
              </TextField>
              <List dense>
                {this.listFields()}
              </List>
            </Grid>
          </Grid>
      </div>
  </Dialog>
  </div>
    );
  }
}


ImportExport.defaultProps = {
  onExport: () => {},
  onImport: () => {},
  toggleImportExport: () => {},
  onTemplateDownload: () => {}
};

ImportExport.propTypes = {
  onExport: PropTypes.func,
  onImport: PropTypes.func,
  toggleImportExport: PropTypes.func,
  onTemplateDownload: PropTypes.func
};

export default withStyles(styles)(ImportExport);

